angular.module('nv.HelpDeskModule.controllers').controller('HelpDeskMasterCtrl', HelpDeskMasterCtrl);

function HelpDeskMasterCtrl(NavService) {
  NavService.closeNav('left');
}
